import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { StatisticDataCardComponent } from '@component/statistical-highlights/statistic-data-card/statistic-data-card.component';
import {
  StatisticalHighlightsComponent
} from '@component/statistical-highlights/statistical-highlights.component';

@NgModule({
  declarations: [StatisticDataCardComponent, StatisticalHighlightsComponent],
  exports: [
    StatisticalHighlightsComponent
  ],
  imports: [CommonModule, InlineSVGModule]
})
export class StatisticalHighlightsModule {}
